import React from 'react';
import { Box } from '@material-ui/core';
import { COLLABORATORS, COORDINATORS } from './peopleData';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Person } from './Person';

export const PeopleSlider = () => (
  <Box style={{ display: 'flex', overflow: 'scroll' }}>
    {COORDINATORS.map(({ size, bio, image, name, job }, i) => (
      <Box style={{ marginRight: '20px' }} key={i}>
        <Person size={size} bio={bio} image={image} name={name} job={job} />
      </Box>
    ))}
    {COLLABORATORS.map(({ size, bio, image, name, job, position }, i) => (
      <Box style={{ marginRight: '20px' }} key={i}>
        <Person
          size={size}
          bio={bio}
          image={image}
          name={name}
          job={job}
          position={position}
        />
      </Box>
    ))}
  </Box>
);
